<template>
  <div
    class="bto-sb-widget bto-sb-widget-category bto-sb-sports-icon bto-sb-category-filtering"
    :class="getSportClass()"
  >
    <div class="bto-sb-widget-title">
      <h3>{{sport.name}}</h3>
    </div>
    <category-tab-component
      v-for="(tournamentId) in processedTids(tournamentIds)"
      :key="tournamentId"
      :sportIn="sport"
      :tabIdx="sport.tabs.findIndex(t => t.id == tournamentId)"
      :is3WaySport="is3WaySport()"
      :markets="markets"
      :isCategoryList="false"
    />
  </div>
</template>

<script>
  import store from '../../../store';

  import CategoryTabComponent from './component-category-tab';

  export default {
    name: 'CategorySportComponent',
    components: {
      CategoryTabComponent,
    },
    props: {
      sport: {
        type: Object,
        required: true,
        default: () => { },
      },
      tournamentIds: {
        type: Array,
        required: true,
        default: () => [],
      }
    },
    data() {
      return {};
    },
    computed: {
      markets() {
        return store.getters.getSportMarkets(this.sport.id);
      }
    },
    watch: {
      sport() {
        store.dispatch('getMarkets', this.sport.id);
      },
    },
    created() {
      store.dispatch('getMarkets', this.sport.id);
    },
    methods: {
      getSportClass() {
        return store.getters.getSportClass(this.sport.id);
      },
      is3WaySport() {
        if (!this.sport) {
          return undefined;
        }
        return this.sport.is3way;
      },
      processedTids() {
        let tabIds = this.sport.tabs.map(tab => tab.id);
        let pTids = this.tournamentIds.map((i) => {
          return i.startsWith('tg') ? i.replace('tg', '') : i;
        });
        pTids = pTids.filter((id) => tabIds.indexOf(parseInt(id)) > -1);
        return pTids.slice().reverse();
      },
    },
  };
</script>
